module.exports = __webpack_public_path__ + "img/Video-To-Watch.a3ec1ce9.svg";